// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
require('./_set-collection-from')('WeakMap');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es7.weak-map.from.js
// module id = 566
// module chunks = 1